<template>
    <div class="dashboard-layout">
      <!-- Здесь размещаются общие элементы (шапка, меню, и т.д.) -->
      <Navbar />
      <!-- Здесь будут отображаться дочерние компоненты -->
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from "./Navbar.vue";
  
  export default {
    name: "DashboardLayout",
    components: {
      Navbar
    }
  };
  </script>
  
  <style scoped>
  .dashboard-layout {
    width: 100%;
    height: 100%;
  }
  .content {
    padding: 20px 0;
  }
  </style>